import React, { useState, useEffect, useMemo } from 'react';
import '@/pages/intelligence/assets/scss/MarketProfile/TabDetails/Insights.scss';
import { Bubble, Alert, Card, Segment, Row, Col, Table } from 'tea-component';

import RangePicker from '@/pages/home/components/RangePicker';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import defaltCountryImg from '@/pages/home/assets/img/flag/default.svg';
import useInsightsModal from '@/pages/intelligence/pages/MarketProfile/TabDetails/hooks/useInsightsModal';
import { pcHasDataCountry, formatP } from '@/pages/intelligence/pages/MarketProfile/_util';
import * as echarts from 'echarts';
import { history, useIntl, getLocale } from 'umi';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import Loading from '@/pages/intelligence/components/Loading';
import NoData from '@/pages/intelligence/components/NoData';
import BigRiserGameList from '@/pages/intelligence/pages/MarketProfile/TabDetails/Insights/components/BigRiserGameList';
import NewRelease from '@/pages/intelligence/pages/MarketProfile/TabDetails/Insights/components/NewRelease';
import TrandTopGame from '@/pages/intelligence/pages/MarketProfile/TabDetails/Insights/components/TrandTopGame';
import moment from 'moment';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { dbiBtnLogMes, dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import xbox from '@/pages/intelligence/assets/svg/marketprofile/xbox.svg';
import playstation from '@/pages/intelligence/assets/svg/marketprofile/playstation.svg';
import nintendo from '@/pages/intelligence/assets/svg/marketprofile/nintendo.svg';
import DataSourceSelector from '@/pages/intelligence/components/TeaSelector/AnnieSource';
import { debounce } from 'lodash-es';
import { dataSourceKey } from '@intelligence/pages/Following/_hook/useFollowingOptionList';
const { selectable, pageable, sortable, scrollable } = Table.addons;

export default function MarketTabDetailsInsights(props: any) {
  const {
    marketName,
    marketNameEn,
    pageId,
    segment,
    changeSegment,
    setActiveId,
    jumpStat,
    activeId,
  } = props;
  const [action, setAction] = useState('chart-map');
  const [sorts, setSorts] = useState<any>([]);
  const [countryId, setCountryId] = useState('');
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const {
    dataSearch,
    resizeHandler,
    lineData,
    cr10DetailSearch,
    SegmentValue,
    setSegmentValue,
    gameTop101,
    gameTop102,
    trendLoad,
    trendLoadDetail,
    trendTime,
    riserData,
    riserTime,
    riserLoad,
    upcomingLoad,
    timeCache,
    setUpcomingTime,
    setReleaseTime,
    setRiserTime,
    setTrendTime,
    dateValue,
    setDateValue,
    cr10TrendSearch,
    bigRiserSearch,
    newReleaseSearch,
    upcomingSearch,
    relaseData,
    relaseTime,
    relaseLoad,
    upcomingData,
    upcomingTime,
    onChangeRangePicker2,
    onChangeDataSource,
    dataSource,
    lineChartDate,
    hasCr10Data,
  } = useInsightsModal({
    countryId,
    marketName,
    marketNameEn,
    pageId,
    segment,
    changeSegment,
    setActiveId,
  });

  const isAnnie: any = useMemo(() => {
    return history.location.query?.isAnnie;
  }, [history.location]);

  useEffect(() => {
    // window.addEventListener('resize', resizeHandler);
    const marketNameEn = marketNameEn || history.location.query.marketNameEn;

    // PC console选项是否可用，只有 countryList 中的国家才可用
    const countryHasPcConsoleData =
      pcHasDataCountry.indexOf(history.location.query.marketNameEn) == -1;
    let type = 'mobile';
    const segmentFromOtherPage = segment;
    if (segmentFromOtherPage != '' && segmentFromOtherPage != 'total' && !countryHasPcConsoleData) {
      type = segmentFromOtherPage;
      setSegmentValue(segmentFromOtherPage);
    }

    const _params = {
      market: marketNameEn,
      entity_type: type,
      start_date: '',
      end_date: '',
      source: dataSourceKey.sensortower,
    };

    dataSearch(_params);
    setCountryId(marketNameEn);
    // return () => {
    //     window.removeEventListener('resize', resizeHandler);
    // };
  }, []);

  // 跳转到stats页面
  const gotoMarketProfileStats = () => {
    const pathStr = '/intelligence/marketProfile/Stats/detail';
    const params = {
      marketName,
      marketNameEn,
      pageId,
      segment,
      dimension: 'game',
      dateRange: lineChartDate,
      dateType: 'daily',
    } as any;

    // 将object形式的数据转换url参数
    const paramsStr = Object.keys(params).reduce((acc, cur, index) => {
      if (!acc.match('=')) {
        acc = `${acc}=${params[acc]}`;
      }
      return `${acc}&${cur}=${params[cur]}`;
    });
    // changeURLStatic(`${pathStr}?${paramsStr}`);
    jumpStat(`${pathStr}?${paramsStr}`);
  };

  // 跳转到游戏详情
  const gotoGameDetailsPage = (val: any, logMes?: any, jump = true) => {
    const path = getDetailGamePathCommon({
      entityType: SegmentValue,
      gameId: val.id || val.app_id,
      tab: 'overview',
    });
    if (jump) {
      buriedBtnPoint(logMes ? logMes : dbiBtnLogMes.marketProfileMobileInsightsRevGame);
      return history.push(path);
    }
    return path;
  };

  const topGameData1 = gameTop101?.map((item: any) => ({
    ...item,
    rank: item.rank,
    list: {
      img: item.gameIcon,
      icon: SegmentValue !== 'mobile' ? item.conutryFlag || defaltCountryImg : null,
      title: item.name,
      text: item.desc,
    },
    dau: formatNum(item.revenue),
    percent: formatP(item.precent),
    platList:
      SegmentValue == 'console'
        ? item.platList?.map((obj: any) => {
            if (obj.toUpperCase() == 'PS') return playstation;
            if (obj.toUpperCase() == 'XBOX') return xbox;
            if (obj.toUpperCase() == 'NINTENDO') return nintendo;

            return '';
          }) || []
        : null,
  }));

  const topGameData2 = gameTop102?.map((item: any) => ({
    ...item,
    rank: item.rank,
    list: {
      img: item.gameIcon,
      icon: SegmentValue !== 'mobile' ? item.conutryFlag || defaltCountryImg : null,
      title: item.name,
      text: item.desc,
    },
    dau: formatNum(item.revenue),
    percent: formatP(item.precent),
    platList:
      SegmentValue == 'console'
        ? item.platList?.map((obj: any) => {
            if (obj.toUpperCase() == 'PS') return playstation;
            if (obj.toUpperCase() == 'XBOX') return xbox;
            if (obj.toUpperCase() == 'NINTENDO') return nintendo;

            return '';
          }) || []
        : null,
  }));

  const { scrollBody } = props;
  const [segmentFixed, setSegmentFixed] = useState(false);

  // 监听页面滚动
  useEffect(() => {
    if (scrollBody.current) {
      const handleScroll = debounce((e: any) => {
        const { scrollTop } = e.srcElement;
        // console.log(scrollTop);

        // 滚动判断距离 和定位条位置相关，开发调整
        if (scrollTop > 260) {
          setSegmentFixed(true);
        } else {
          setSegmentFixed(false);
        }
      }, 100);
      scrollBody.current?.addEventListener('scroll', handleScroll, false);
      return () => scrollBody.current?.removeEventListener('scroll', handleScroll, false);
    }
  }, [scrollBody]);

  return (
    <div className="dbi-market-tabdetails--insights">
      <div className="dbi-market-tabdetails-segment">
        <Segment
          className="segment-light"
          value={SegmentValue}
          onChange={(value: string) => {
            if (trendLoad || trendLoadDetail || riserLoad || relaseLoad || upcomingLoad) {
              return;
            }

            const time = timeCache[value];
            let dateTime = time;
            if (dateTime == '') {
              dateTime = moment().format('YYYY-MM-DD');
            } else {
              setUpcomingTime(dateTime);
              setReleaseTime(dateTime);
              setRiserTime(dateTime);
              setTrendTime(dateTime);
            }

            dateValue.length = 0;
            dateValue.push(...[dateTime]);
            setDateValue(dateValue);
            const _params = {
              market: countryId,
              entity_type: value,
              start_date: time,
              end_date: time,
              source: dataSource,
            };
            changeSegment && changeSegment(value);
            cr10TrendSearch(_params, time == '');
            bigRiserSearch(_params, time == '');
            newReleaseSearch(_params, time == '');
            upcomingSearch(_params, time == '');
            setSegmentValue(value);

            history.replace(
              `/intelligence/marketProfile/${activeId}/detail?marketName=${marketName}&marketNameEn=${marketNameEn}&pageId=${pageId}&segment=${value}${
                isAnnie ? `&isAnnie=${isAnnie}` : ''
              }`,
            );
          }}
          options={[
            {
              value: 'mobile',
              text: formatMessage({ id: 'dbi_market_mobile' }),
            },
            {
              value: 'pc',
              text:
                pcHasDataCountry.indexOf(history.location.query.marketNameEn) == -1 ? (
                  <Bubble
                    dark
                    arrowPointAtCenter
                    placement="bottom"
                    content={
                      <div style={{ whiteSpace: 'pre-wrap', maxWidth: '400px' }}>
                        The data for this game type is unavailable in current country or area.
                        <br />
                        此游戏类型的数据在当前国家或地区不可用。
                      </div>
                    }
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {formatMessage({ id: 'dbi_market_pc' })}
                    </div>
                  </Bubble>
                ) : (
                  formatMessage({ id: 'dbi_market_pc' })
                ),
              disabled: pcHasDataCountry.indexOf(history.location.query.marketNameEn) == -1,
            },
            {
              value: 'console',
              text:
                pcHasDataCountry.indexOf(history.location.query.marketNameEn) == -1 ? (
                  <Bubble
                    dark
                    arrowPointAtCenter
                    placement="bottom"
                    content={
                      <div style={{ whiteSpace: 'pre-wrap', maxWidth: '400px' }}>
                        The data for this game type is unavailable in current country or area.
                        <br />
                        此游戏类型的数据在当前国家或地区不可用。
                      </div>
                    }
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {formatMessage({ id: 'dbi_market_console' })}
                    </div>
                  </Bubble>
                ) : (
                  formatMessage({ id: 'dbi_market_console' })
                ),
              disabled: pcHasDataCountry.indexOf(history.location.query?.marketNameEn) == -1,
            },
          ]}
        />

        {/* 仅占位*/}
        <div className="search-item search-item-date">
          <RangePicker
            type="date"
            calendarType="date"
            language={locale === LANGUAGE_CN ? 'cn' : 'en'}
            autoRange={{
              timeType: 'date',
              length: 0,
            }}
            disabledDate={(date: any) => !date.isAfter(moment())}
            value={
              dateValue.length > 0
                ? [moment(dateValue[0]), moment(dateValue[0])]
                : [moment(), moment()]
            }
            className="search-border"
            showSelectType={false}
            showShortcut={false}
            onChange={(value: any) => {
              onChangeRangePicker2(value[0], true);
            }}
          />
        </div>

        {SegmentValue === 'mobile' && (
          <DataSourceSelector
            type={'single'}
            key={'dataSourceSingle'}
            locale={locale}
            onConfirm={onChangeDataSource}
            value={dataSource}
            isSearchItemMargin={true}
          />
        )}
      </div>

      {/* 吸顶内容 */}

      <div className={`header-segment ${segmentFixed ? 'visible' : 'hide'}`}>
        <div className="dbi-market-tabdetails-segment">
          <Segment
            value={SegmentValue}
            onChange={(value: string) => {
              if (trendLoad || trendLoadDetail || riserLoad || relaseLoad || upcomingLoad) {
                return;
              }

              const time = timeCache[value];
              let dateTime = time;
              if (dateTime == '') {
                dateTime = moment().format('YYYY-MM-DD');
              } else {
                setUpcomingTime(dateTime);
                setReleaseTime(dateTime);
                setRiserTime(dateTime);
                setTrendTime(dateTime);
              }

              dateValue.length = 0;
              dateValue.push(...[dateTime]);
              setDateValue(dateValue);
              const _params = {
                market: countryId,
                entity_type: value,
                start_date: time,
                end_date: time,
                source: dataSource,
              };
              changeSegment && changeSegment(value);
              cr10TrendSearch(_params, time == '');
              bigRiserSearch(_params, time == '');
              newReleaseSearch(_params, time == '');
              upcomingSearch(_params, time == '');
              setSegmentValue(value);

              history.replace(
                `/intelligence/marketProfile/${activeId}/detail?marketName=${marketName}&marketNameEn=${marketNameEn}&pageId=${pageId}&segment=${value}${
                  isAnnie ? `&isAnnie=${isAnnie}` : ''
                }`,
              );
            }}
            options={[
              {
                value: 'mobile',
                text: formatMessage({ id: 'dbi_market_mobile' }),
              },
              {
                value: 'pc',
                text:
                  pcHasDataCountry.indexOf(history.location.query.marketNameEn) == -1 ? (
                    <Bubble
                      dark
                      arrowPointAtCenter
                      placement="bottom"
                      content={
                        <div style={{ whiteSpace: 'pre-wrap', maxWidth: '400px' }}>
                          The data for this game type is unavailable in current country or area.
                          <br />
                          此游戏类型的数据在当前国家或地区不可用。
                        </div>
                      }
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {formatMessage({ id: 'dbi_market_pc' })}
                      </div>
                    </Bubble>
                  ) : (
                    formatMessage({ id: 'dbi_market_pc' })
                  ),
                disabled: pcHasDataCountry.indexOf(history.location.query.marketNameEn) == -1,
              },
              {
                value: 'console',
                text:
                  pcHasDataCountry.indexOf(history.location.query.marketNameEn) == -1 ? (
                    <Bubble
                      dark
                      arrowPointAtCenter
                      placement="bottom"
                      content={
                        <div style={{ whiteSpace: 'pre-wrap', maxWidth: '400px' }}>
                          The data for this game type is unavailable in current country or area.
                          <br />
                          此游戏类型的数据在当前国家或地区不可用。
                        </div>
                      }
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {formatMessage({ id: 'dbi_market_console' })}
                      </div>
                    </Bubble>
                  ) : (
                    formatMessage({ id: 'dbi_market_console' })
                  ),
                disabled: pcHasDataCountry.indexOf(history.location.query?.marketNameEn) == -1,
              },
            ]}
          />

          {/* 仅占位*/}
          <div className="search-item search-item-date">
            <RangePicker
              type="date"
              language={locale === LANGUAGE_CN ? 'cn' : 'en'}
              calendarType="date"
              autoRange={{
                timeType: 'date',
                length: 0,
              }}
              disabledDate={(date: any) => !date.isAfter(moment())}
              value={
                dateValue.length > 0
                  ? [moment(dateValue[0]), moment(dateValue[0])]
                  : [moment(), moment()]
              }
              className="search-border"
              showSelectType={false}
              showShortcut={false}
              onChange={(value: any) => {
                onChangeRangePicker2(value[0], true);
              }}
            />
          </div>

          {SegmentValue === 'mobile' && (
            <DataSourceSelector
              type={'single'}
              key={'dataSourceSingle'}
              locale={locale}
              onConfirm={onChangeDataSource}
              value={dataSource}
              isSearchItemMargin={true}
            />
          )}
        </div>
      </div>

      <CardSlot
        title={formatMessage({ id: 'dbi_market_cr10' })}
        className="tabdetails-rowtop"
        iconList={null}
        activeTab={action}
        // getDetails={gotoMarketProfileStats}
        // isAction={true}
        getChange={(icon: any) => {
          setAction(icon);
        }}
      >
        {trendLoad ? (
          <div style={{ height: 772 }}>
            <Loading content={formatMessage({ id: 'common_loading' })} />
          </div>
        ) : (
          <TrandTopGame
            SegmentValue={SegmentValue}
            dataSource={dataSource}
            time={trendTime}
            trendLoad={trendLoad}
            trendLoadDetail={trendLoadDetail}
            topGameData1={topGameData1}
            topGameData2={topGameData2}
            gotoGameDetailsPage={gotoGameDetailsPage}
            gameType={SegmentValue}
            lineData={lineData}
            hasCr10Data={hasCr10Data}
            cr10DetailSearch={cr10DetailSearch}
            marketName={marketName}
            gotoMarketProfileStats={gotoMarketProfileStats}
          />
        )}
      </CardSlot>
      <BigRiserGameList
        data={riserData}
        time={riserTime ? moment(riserTime).format('MMM DD,YYYY') : null}
        riserLoad={riserLoad}
        title={`${formatMessage({ id: 'dbi_market_big_riser' })} ${
          SegmentValue == 'pc'
            ? formatMessage({ id: 'dbi_pc_games' })
            : SegmentValue == 'mobile'
            ? formatMessage({ id: 'dbi_mobile_games' })
            : formatMessage({ id: 'dbi_console_games' })
        }`}
        gameType={SegmentValue}
        needTitle={true}
        gotoGameDetailsPage={gotoGameDetailsPage}
      />
      <NewRelease
        type="newRelease"
        data={relaseData}
        time={relaseTime ? moment(relaseTime).format('MMM DD,YYYY') : null}
        loading={relaseLoad}
        title={`${formatMessage({ id: 'dbi_store_rank_new_release' })} ${
          SegmentValue == 'pc'
            ? formatMessage({ id: 'dbi_pc_games' })
            : SegmentValue == 'mobile'
            ? formatMessage({ id: 'dbi_mobile_games' })
            : formatMessage({ id: 'dbi_console_games' })
        }`}
        gameType={SegmentValue}
        needTitle={true}
        gotoGameDetailsPage={gotoGameDetailsPage}
      />
      <NewRelease
        type="upComing"
        data={upcomingData}
        time={upcomingTime ? moment(upcomingTime).format('MMM DD,YYYY') : null}
        loading={upcomingLoad}
        title={`${formatMessage({ id: 'dbi_store_rank_upcoming' })} ${
          SegmentValue == 'pc'
            ? formatMessage({ id: 'dbi_pc_games' })
            : SegmentValue == 'mobile'
            ? formatMessage({ id: 'dbi_mobile_games' })
            : formatMessage({ id: 'dbi_console_games' })
        }`}
        gameType={SegmentValue}
        needTitle={true}
        gotoGameDetailsPage={gotoGameDetailsPage}
      />
    </div>
  );
}
